import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import {Button, TextField} from "@mui/material";
import {useRef, useState} from "react";
import {CheckCircle, NavigateNext} from "@mui/icons-material";
import Box from "@mui/material/Box";
import useInterventionRepository from "../../../../../../repository/insurance/useInterventionRepository";
import Intervention from "../../../../../../entity/insurance/Intervention";
import isNull from "../../../../../../mixin/isNull";
import useAlert from "../../../../../../use/useAlert";
import parameter from "../../../../../../enum/parameter";
import QuotationDetails from "../common/QuotationDetails";
import NotifyWork from "./NotifyWork";
import NotifyIdentifyIssue from "./report-step/NotifyIdentifyIssue";

const ERROR_COMMENT_REQUIRED = "Veuillez décrire les travaux réalisés.";

export default function ({interventionId}) {
    const alert = useAlert();
    const interventionRepository = useInterventionRepository();
    const [loading, setLoading] = useState(false);
    const [reportStep, setReportStep] = useState(0);
    const worksComment = useRef(null);

    const handleCommentChange = e => {
        worksComment.current = e.target.value || null;
    }

    const nextStep = async () => {
        setLoading(true);

        if (isNull(worksComment.current)) {
            alert.warning(ERROR_COMMENT_REQUIRED);
            setLoading(false);
            return;
        }

        const res = await interventionRepository.updateCurrentStep(interventionId, {
            intervention: {
                current_step: Intervention.STEP_WORKS,
                works_comment: worksComment.current
            }
        });

        if (!res) setLoading(false);
    }

    if (reportStep === 0) {
        return (
            <>
                <Body>
                    <Box mt={2}>
                        <NotifyWork/>
                    </Box>
                </Body>
                <Footer>
                    <Button
                        sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                        startIcon={<NavigateNext/>}
                        variant="contained"
                        size="small"
                        fullWidth
                        onClick={() => setReportStep(1)}
                        data-test="insurance-button-next-step"
                    >
                        Compléter le compte rendu
                    </Button>
                </Footer>
            </>
        );
    }

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyIdentifyIssue/>
                </Box>
                <Box px={2} mt={4}>
                    <TextField
                        label="Travaux réalisés"
                        multiline
                        rows={6}
                        fullWidth
                        onChange={handleCommentChange}
                        slotProps={{htmlInput: {"data-test": "insurance-input-works-comment"}}}
                    />
                </Box>
                <Box mt={4} px={2}>
                    <QuotationDetails interventionId={interventionId}/>
                </Box>
            </Body>
            <Footer>
                <Button
                    variant="contained"
                    size="small"
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    fullWidth
                    onClick={nextStep}
                    disabled={loading}
                    data-test="insurance-button-next-step"
                >
                    Valider les travaux
                </Button>
            </Footer>
        </>
    );
}
